import { FC } from 'react';
import { Modal } from 'react-bootstrap';
import { useTranslate } from 'hooks/useTranslate';

import Button, { ButtonVariants } from 'modules/_shared/components/Buttons';

import { useAcceptTradingOfferModal } from '../context/AcceptTradingOfferModalContext';

const hasRequiredText = (value: string | undefined) =>
  typeof value === 'string' && value.trim().length > 0;

const AcceptTradingOfferModalFooter: FC = () => {
  const { t } = useTranslate();
  const { data, actions } = useAcceptTradingOfferModal();

  const buyer = data.partnerBuyer;
  const address = buyer?.address;

  const isStep2Valid =
    !!buyer &&
    hasRequiredText(buyer.name) &&
    hasRequiredText(buyer.cif) &&
    hasRequiredText(buyer.email) &&
    hasRequiredText(buyer.phone) &&
    hasRequiredText(address?.line1) &&
    hasRequiredText(address?.zip) &&
    hasRequiredText(address?.city) &&
    hasRequiredText(address?.country) &&
    data.buyerDocuments.length > 0 &&
    data.isDataVerified;
  const isStep3Valid =
    data.isTermsAccepted &&
    data.isPurchaseContractAccepted &&
    data.isIrrevocableAccepted &&
    data.isFiscalAccepted;

  const canContinue =
    data.currentStep === 1 || (data.currentStep === 2 && isStep2Valid);

  return (
    <Modal.Footer className="d-flex justify-content-between border-top">
      <div>
        {data.currentStep > 1 && (
          <Button
            variant={ButtonVariants.SECONDARY}
            outlineStyle
            icon="arrow-left"
            onClick={actions.handlePrevStep}
          >
            {t('Previous')}
          </Button>
        )}
      </div>

      <div className="d-flex">
        <Button
          variant={ButtonVariants.SECONDARY}
          outlineStyle
          onClick={actions.handleCloseModal}
        >
          {t('Cancel')}
        </Button>

        {data.currentStep < 3 && (
          <Button
            className="ml-2"
            onClick={actions.handleNextStep}
            disabled={!canContinue}
          >
            {t('Continue')}
            <em className="icon ni ni-arrow-right ml-1" />
          </Button>
        )}

        {data.currentStep === 3 && (
          <Button
            variant={ButtonVariants.SUCCESS}
            icon="check"
            className="ml-2"
            onClick={actions.handleConfirmPurchase}
            disabled={!isStep3Valid}
          >
            {t('ConfirmPurchase')}
          </Button>
        )}
      </div>
    </Modal.Footer>
  );
};

export default AcceptTradingOfferModalFooter;
